module.exports = __webpack_public_path__ + "img/floorFive.77c8cbeb.png";